<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-date-picker
                    v-model="servetime"
                    type="datetimerange"
                    :picker-options="pickerOptions"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="left"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    @change="dateChange"
                ></el-date-picker>
            </el-form-item>
            <el-form-item class="query-form-item" label="订单状态">
                <el-select
                    v-model="query.fieldE2Serc"
                    placeholder="全部"
                    @change="onSubmit"
                    clearable
                >
                    <el-option label="待支付" value="option1"></el-option>
                    <el-option label="已排产" value="wT6Sahgme"></el-option>
                    <el-option label="已包装" value="c5Bfbik92"></el-option>
                    <el-option label="已发货" value="F3x1O8cU9"></el-option>
                    <el-option label="已完成" value="2CC9yH20F"></el-option>
                    <el-option label="其他" value="other"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-input
                    placeholder="订单号"
                    v-model="query.content"
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit"
                    clearable
                >
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-refresh"
                    @click="onRest"
                ></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit"
                >查询</el-button
                >
             <!--   <el-button
                    type="primary"
                    icon="el-icon-download"
                    size="small"
                    @click="exportExcel()"
                >导出</el-button
                >-->
            </el-form-item>
        </el-form>
        <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
            @selection-change="handleSelectionChange"
            border
        >
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column label="用户名"   prop="user.useremail" align="center"></el-table-column>
            <!--<el-table-column label="分享逍客负责人" align="center" width="150" prop="owner"/>-->
            <!--<el-table-column label="分享逍客的订单系统编号" align="left" prop="fieldBoi6lC"/>-->
            <el-table-column label="分享逍客订单编号" align="center" prop="field8eocvC"/>
            <el-table-column label="订单状态"  width="100" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.fieldE2serC == 'option1'">待支付</span>
                    <span v-if="scope.row.fieldE2serC == 'wT6Sahgme'">已排产</span>
                    <span v-if="scope.row.fieldE2serC == 'c5Bfbik92'">已包装</span>
                    <span v-if="scope.row.fieldE2serC == 'F3x1O8cU9'">已发货</span>
                    <span v-if="scope.row.fieldE2serC == '2CC9yH20F'">已完成</span>
                    <span v-if="scope.row.fieldE2serC == 'other'">其他</span>
                </template>
            </el-table-column>
            <el-table-column label="运输方式" align="center" width="100" >
                <template slot-scope="scope">
                    <span v-if="scope.row.field62jp7C == 'option1'">海运</span>
                    <span v-else-if="scope.row.field62jp7C == 'D1i6WW0rf'">空运</span>
                    <span v-else>其他</span>
                </template>
            </el-table-column>
            <el-table-column label="运单码" align="center" prop="fieldA9w3uC"/>
            <el-table-column label="负责人主属部门" align="center" prop="ownerDepartment"/>
           <!-- <el-table-column label="最后修改人" align="center" width="150" prop="lastModifiedBy"/>-->

            <el-table-column label="逍客创建时间" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span>{{
            scope.row.createTime | formatDateStr("yyyy-MM-dd hh:mm:ss")
          }}</span>
                </template>
            </el-table-column>
            <!--<el-table-column label="处理状态"  width="100" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.serveorderstatus == 0">待处理</span>
                    <span v-if="scope.row.serveorderstatus == 1">已处理</span>
                </template>
            </el-table-column>-->
        </el-table>
        <div class="left-container">
            <el-button type="primary" size="small" @click="synchronizationXk() " plain>同步逍客</el-button>
        </div>


        <el-pagination
            class="pagination-container"
            background
            :current-page="query.currentPage"
            :page-size="query.pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper"
            :page-sizes="[10, 20, 30, 50]"
            :total="totalNumber"
        ></el-pagination>

        <!--  查看 --->

    </div>
</template>

<script>
    import {getList , synchronization} from "../../api/order/shareXkOrder.js";
    const formJson = {
    };
    export default {
        data() {
            return {
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近六个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                cancelToggle: false,
                servetime: [],
                query: {
                    content:"",
                    fieldBOi6lc:"",//分享逍客的订单系统编号
                    fieldE2Serc:"",//订单状态
                    startTime: "",
                    endTime: "",
                    currentPage: 1,
                    pageSize: 10
                },
                list: [],
                totalNumber: 0,
                loading: true,
                index: null,
            };
        },
        methods: {
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.getList();
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },

            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10
                };
                this.servetime = [];
                this.getList();
            },

            onSubmit() {

                // this.$router.push({
                //     path: "",
                //     query: this.query
                // });
                this.getList();
            },

            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },

            getList() {
                this.loading = true;
                getList(this.query)
                    .then(response => {

                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.list = response.data.list || [];
                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            //导出
        /*    exportExcel() {
                window.location.href = BASE_URL + "/serveOrderManage/export";
            },*/

            //同步逍客
            synchronizationXk() {
                    this.$confirm("确认要同步吗?", "提示", {
                        type: "warning"
                    })
                        .then(() => {
                            this.loading = true;
                            var params = new URLSearchParams();
                            synchronization(params)
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("同步成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.getList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
            }

        },
        mounted() {},
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
        }
    };
</script>

<style type="text/scss" lang="scss">
    body {
        margin: 0;
    }
</style>
